module.exports = __webpack_public_path__ + "src/assets/img/unity.46d2a1fe.jpg";